import React, { useState } from 'react';
import { Button, Tooltip } from '@mui/material';
import { Feature } from '@loyalty/shared-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QlfConfirmationDialog, useAlerts, useConfirmationDialog } from '@qualifio/ui-commons';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { useTranslation } from 'react-i18next';
import { useApi } from '../../../shared/api-client/ApiClientProvider';
import { useFeatures } from '../../../features/FeaturesContext';

export function DeletePromocode({
  rewardId,
  promocodeId,
  onDeleted,
}: {
  rewardId: string;
  promocodeId: string;
  onDeleted: () => void;
}) {
  const { t } = useTranslation();

  const { notify } = useAlerts();
  const [loading, setLoading] = useState(false);
  const { features } = useFeatures();
  const { remove: promocodeRemove } = features[Feature.PROMOCODE];

  const { rewardsApi } = useApi();

  const deleteUnwon = async () => {
    rewardsApi
      .deletePromocode(rewardId, promocodeId)
      .then(onDeleted)
      .catch(() => notify(t('rewards.promo-codes.errors.delete'), 'error'))
      .finally(() => setLoading(false));
  };

  const { confirmationDialogState, setConfirmationDialogState } = useConfirmationDialog();
  const openDialog = () => {
    setConfirmationDialogState({
      title: t('rewards.promo-codes.confirm.deletion.title'),
      content: t('rewards.promo-codes.confirm.deletion.message'),
      confirmButtonText: t('generic.actions.hard-delete'),
      cancelButtonText: t('generic.actions.cancel'),
      open: true,
      onConfirm: () => deleteUnwon(),
    });
  };

  return (
    <>
      <QlfConfirmationDialog {...confirmationDialogState} />
      <Tooltip title={promocodeRemove ? '' : t('shared.action.permission.required')}>
        <div>
          <Button
            color="error"
            size="small"
            startIcon={<FontAwesomeIcon icon={faTrash} />}
            disabled={!promocodeRemove}
            onClick={() => openDialog()}
          >
            {t('rewards.promo-codes.button.delete-promo-code')}
          </Button>
        </div>
      </Tooltip>
    </>
  );
}
